/* istanbul ignore file */

export { Quotes as default } from "./Quotes";
